import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Header } from 'semantic-ui-react';
import { sysAPI } from '../../../../apis/SysAPI';
import { responseError } from '../../../../helpers';
import { useDispatch } from 'react-redux';
import TableFpAlpha from '../../../../components/Table';
import Loading from '../../../../components/globals/Loading';

const ReturnFlags = forwardRef(({ activeIndex, startDate, endDate, areas, loading, excludeCompanies, includeCompanies, setLoading }, ref) => {
    const dispatch = useDispatch();
    const [items, setItems] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [internalLoading, setIntenalLoading] = useState(false)

    const getData = async () => {
        setLoading(true);
        setIntenalLoading(true);
        try {
            const { data } = await sysAPI.get(`/metrics/tables/return-flags`, {
                params: {
                    startDate,
                    endDate,
                    areas: areas.join(','),
                    excludeCompanies: excludeCompanies.join(','),
                    includeCompanies: includeCompanies.join(','),
                },
            });
            setItems(data?.data?.items || []);
            setHeaders(data?.data?.headers || []);
        } catch (error) {
            responseError(error, undefined, 'ReturnFlags.getData', dispatch);
        }
        setLoading(false);
        setIntenalLoading(false);
    };

    useImperativeHandle(ref, () => ({
        getData: getData,
    }));

    useEffect(() => {
        getData();

        // eslint-disable-next-line
    }, [activeIndex]);

    return (
        <div className='card_metrics'>
            {internalLoading ? <>
                <Loading />
            </> : <>
                <Header textAlign="center" as="h3">
                    Return Flags
                </Header>
                <div>
                    <TableFpAlpha
                        headers={headers}
                        data={items}
                        positionHeaders="center"
                    >
                        <div slot={"_id"} render={({ data }) => (
                                <>{data._id} {/* ({data.total}) */}</>
                            )} />
                    </TableFpAlpha>
                </div>
            </>}
        </div>
    );
});

export default ReturnFlags;
